/* Werk-Detail: Umschalter Werk / Raumansicht und Vollbild-Lightbox.
   Verhalten wie in der Vorlage — Escape schließt das Vollbild. */
(function () {
  var room = document.querySelector('[data-wa-room]');
  var artwork = document.querySelector('[data-wa-artwork]');
  var roomToggle = document.querySelector('[data-wa-room-toggle]');
  var roomHint = document.querySelector('[data-wa-room-hint]');
  var lightbox = document.querySelector('[data-wa-lightbox]');

  var showingRoom = false;

  function setRoom(next) {
    if (!room || !artwork) return;
    showingRoom = next;

    room.hidden = !next;
    artwork.hidden = next;
    if (roomHint) roomHint.hidden = !next;

    if (roomToggle) {
      roomToggle.textContent = next ? roomToggle.dataset.waLabelWork : roomToggle.dataset.waLabelRoom;
    }

    // waFade beim Umschalten neu auslösen.
    var shown = next ? room : artwork;
    shown.style.animation = 'none';
    void shown.offsetWidth;
    shown.style.animation = '';
  }

  if (roomToggle) {
    roomToggle.addEventListener('click', function () {
      setRoom(!showingRoom);
    });
  }

  function openLightbox() {
    if (!lightbox) return;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = lightbox.querySelector('[data-wa-lightbox-close]');
    if (close) close.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-wa-lightbox-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      // In der Raumansicht öffnet ein Klick auf die Bühne kein Vollbild.
      if (trigger.hasAttribute('data-wa-artwork') && showingRoom) return;
      openLightbox();
    });
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('.wa-lightbox__caption')) return;
      closeLightbox();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeLightbox();
    });
  }

  /* ---------- Mitlaufende Kopfleiste ----------
     Sobald das Werk oben aus dem Bild gescrollt ist, zeigt eine schmale Leiste
     unter der Navigation Titel, Maß und Preis — wie in der Vorlage. */
  (function () {
    var bar = document.querySelector('[data-wa-workbar]');
    var media = document.querySelector('[data-wa-work-media]');
    var nav = document.querySelector('[data-wa-nav]');
    if (!bar || !media) return;

    var frame = null;

    function apply() {
      frame = null;
      var navH = nav ? nav.getBoundingClientRect().height : 88;
      var on = media.getBoundingClientRect().bottom < navH + 12;
      if (on === !bar.hidden) return;
      bar.hidden = !on;
      bar.style.top = navH + 'px';
    }

    window.addEventListener(
      'scroll',
      function () {
        if (frame === null) frame = window.requestAnimationFrame(apply);
      },
      { passive: true }
    );

    apply();
  })();

  /* ---------- Aufklappbare Angaben ---------- */
  document.querySelectorAll('[data-wa-fact-toggle]').forEach(function (head) {
    var fact = head.closest('.wa-fact');
    var body = fact && fact.querySelector('[data-wa-fact-body]');
    var sign = head.querySelector('.wa-fact__sign');
    if (!body) return;

    head.addEventListener('click', function () {
      var open = fact.hasAttribute('data-open');
      if (open) {
        fact.removeAttribute('data-open');
        body.style.maxHeight = '0px';
      } else {
        fact.setAttribute('data-open', '1');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
      head.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (sign) sign.textContent = open ? '+' : '−';
    });
  });

  /* ---------- Zuletzt angesehen ----------
     Die Vorlage merkt sich die zuletzt geöffneten Werke im Browser. Gespeichert
     wird nur, was zur Anzeige der Kachel nötig ist. */
  (function () {
    // v2, weil frühere Listen noch Gutscheine enthalten können.
    var KEY = 'wa.recent.v2';
    var LIMIT = 6;

    var work = document.querySelector('[data-wa-work]');
    var strip = document.querySelector('[data-wa-recent]');
    var grid = document.querySelector('[data-wa-recent-grid]');
    if (!work || !strip || !grid) return;

    // Gutscheine sind keine Werke und gehören nicht in die Liste.
    var remember = work.dataset.recent !== 'false';

    var current = {
      handle: work.dataset.handle,
      title: work.dataset.title,
      price: work.dataset.price,
      image: work.dataset.image,
      url: window.location.pathname
    };

    var list = [];
    try {
      list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) list = [];
    } catch (e) {
      list = [];
    }

    // Erst die vorher gesehenen Werke zeigen, dann das aktuelle vormerken.
    var others = list.filter(function (w) {
      return w && w.handle && w.handle !== current.handle;
    });

    if (others.length) {
      others.slice(0, LIMIT).forEach(function (w) {
        var a = document.createElement('a');
        a.className = 'wa-recent__item';
        a.href = w.url || '/products/' + w.handle;

        var mat = document.createElement('span');
        mat.className = 'wa-recent__mat';
        var img = document.createElement('img');
        img.className = 'wa-recent__img';
        img.src = w.image;
        img.alt = '';
        img.loading = 'lazy';
        mat.appendChild(img);

        var title = document.createElement('span');
        title.className = 'wa-serif wa-recent__title';
        title.textContent = w.title;

        var price = document.createElement('span');
        price.className = 'wa-recent__price';
        price.textContent = w.price;

        a.appendChild(mat);
        a.appendChild(title);
        a.appendChild(price);
        grid.appendChild(a);
      });
      strip.hidden = false;
      // Die Kacheln entstehen erst jetzt — die Laufleiste neu messen.
      document.dispatchEvent(new CustomEvent('wa:rails'));
    }

    if (!remember) return;

    var next = [current].concat(others).slice(0, LIMIT + 1);
    try {
      window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {
      /* Speicher voll oder gesperrt — die Seite funktioniert auch ohne. */
    }
  })();
})();
